/*
 * Copyright (c) 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import TSAbstractEntity from './TSAbstractEntity';
import TSBankverbindung from './TSBankverbindung';
import {TSSerializable} from './TSSerializable';

export default class TSVersicherung extends TSAbstractEntity implements TSSerializable<TSVersicherung> {

    private _name: string;
    private _prozentsatz: string;
    private _bankverbindung: TSBankverbindung;

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get prozentsatz(): string {
        return this._prozentsatz;
    }

    public set prozentsatz(value: string) {
        this._prozentsatz = value;
    }

    public get bankverbindung(): TSBankverbindung {
        return this._bankverbindung;
    }

    public set bankverbindung(value: TSBankverbindung) {
        this._bankverbindung = value;
    }

    deserialize(restObject: any): TSVersicherung {
        super.deserialize(restObject);

        this.name = restObject.name;
        this.prozentsatz = restObject.prozentsatz;
        if (restObject.bankverbindung) {
            this.bankverbindung = new TSBankverbindung().deserialize(restObject.bankverbindung);
        }

        return this;
    }

    public static deserializeArray(data: any): Array<TSVersicherung> {
        let anlaufstelleArray: Array<TSVersicherung> = [];
        if (data && Array.isArray(data)) {
            for (let i = 0; i < data.length; i++) {
                anlaufstelleArray[i] = new TSVersicherung().deserialize(data[i]);
            }
        } else {
            anlaufstelleArray[0] = new TSVersicherung().deserialize(data);
        }
        return anlaufstelleArray;
    }

    public static getDeserializer = (versicherung: any) => {
        return new TSVersicherung().deserialize(versicherung);
    };

    serialize(restObject: any): any {
        super.serialize(restObject);
        /*not needed*/  //wir brauchen nur die id da nicht anpassbar auf client
        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSVersicherung.ts